import { useTranslation } from 'react-i18next';
import './style.css';

const HeaderInfo = ({ data }) => {
    const { t } = useTranslation();
    return (
        <div className="patient-header-info-section">
            <div className="patient-header-info-item">
                <span className="patient-header-info-label">{t('name').toUpperCase()}</span>
                <h3 className="patient-header-info-value">{data?.name}</h3>
            </div>
            <div className="patient-header-info-item">
                <span className="patient-header-info-label">{t('age').toUpperCase()}</span>
                <h3 className="patient-header-info-value">{data?.age }</h3>
            </div>
            <div className="patient-header-info-item">
                <span className="patient-header-info-label">{t('id').toUpperCase()}</span>
                <h3 className="patient-header-info-value patient-header-info-id">#{data?.id}</h3>
            </div>
        </div>
    );
};

export default HeaderInfo;

